<template>
  <div :class="view">
    <component :is="view"></component>
    <!-- <socket :plat="true"></socket> -->
    <!-- 私聊消息通知的音频 -->
    <!-- <audio ref="recePriMsgAudio" preload="true">
      <source src="@/assets/voices/sms-received.mp3" type="audio/mpeg" />
      <source src="@/assets/voices/sms-received.ogg" type="audio/ogg" />
      {{ $tex("您的浏览器不支持audio标签") }}
    </audio>
    <my-dialog
      class="notice-dlg"
      v-model="allowedNotice"
      :modal="false"
      btnSure=""
      btnCancle=""
      :title="$tex('通知')"
    >
      <i class="iconfont icon-close" @click.stop="closePrivateMsgDialog"></i>
      <div @click.stop="jumpNotice">
        {{ $tex("您有一条私聊信息！") }}
      </div>
    </my-dialog>
    <my-dialog
      class="notice-dlg"
      v-model="showPushMemberMsg"
      :modal="false"
      btnSure=""
      btnCancle=""
      :title="$tex('推送消息')"
    >
      <i class="iconfont icon-close" @click.stop="closeMemberMsgDialog"></i>
      <div @click.stop="jumpMemberMsg">
        {{ memberMsgTitle }}
      </div>
    </my-dialog>
    <sys-notice v-if="showNotice"></sys-notice> -->
  </div>
</template>

<script>
const vLayout = () =>
  import(/* webpackChunkName: "layout" */ "@/views/layout/layout");
const vLayout2 = () =>
  import(/* webpackChunkName: "layout2" */ "@/views2/layout/layout");
const vLayout5 = () =>
  import(/* webpackChunkName: "layout5" */ "@/views5/layout/layout");
const vLayout7 = () =>
  import(/* webpackChunkName: "layout5" */ "@/views7/layout/layout");
const vLayout8 = () =>
  import(/* webpackChunkName: "layout5" */ "@/views8/layout/layout");

import Socket from "@/components/Socket";
import { mapGetters } from "vuex";
import MyDialog from "@/components/MyDialog"; //通知组件
import isEmpty from "lodash/isEmpty";
import * as RongYun from "@/utils/rongyun";
import SysNotice from "@/views/home/sys_notice.vue";
import { Dialog } from "vant";
import Util from "@/utils/util";
import nativeAppUtil from "@/utils/nativeAppUtil";
import { downappurl } from "@/api/user.js";
const BODY_CLASS_NAME = "modal-open";

export default {
  components: {
    vLayout,
    vLayout2,
    vLayout5,
    vLayout7,
    vLayout8,
    Socket,
    MyDialog,
    SysNotice
  },
  data() {
    return {
      showPushMemberMsg: false,
      memberMsgTitle: "",
      msgUId: -1,
      hisInfo: null,
      priMsgTimer: "", //隐藏私信通知的计时器
      showNotice: false
    };
  },
  computed: {
    ...mapGetters([
      "pageTemplate",
      "chatPushMemberMsg",
      "user",
      "isShowSinglePrivateMsgNotice",
      "isOpenPrivateMsgNoticeSwitch",
      "appLoad",
      "h5CanReceiveRedPacket"
    ]),
    view() {
      // this.pageTemplate.index
      let verseion = "2" || "";
      return "vLayout" + verseion;
    },
    allowedNotice: {
      //是否显示私聊消息通知
      get() {
        const {
          isShowNotice,
          hisInfo,
          messageUId
        } = this.isShowSinglePrivateMsgNotice;
        if (this.msgUId === messageUId) {
          //同一消息不执行
          return;
        }
        this.msgUId = messageUId;
        this.hisInfo = hisInfo;
        let flag =
          isShowNotice &&
          "chatMain" !== this.$route.name &&
          this.isOpenPrivateMsgNoticeSwitch;
        // this.priMsgTimer && clearTimeout(this.priMsgTimer);
        if (flag) {
          this.playMsgVoice();
          // this.priMsgTimer = setTimeout(() => {
          //   this.closePrivateMsgDialog();
          // }, 4000);
        }
        return flag;
      },
      set() {}
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.handleShowNotice();
        this.toggleHomeClz();
      }
    },
    show(v) {
      if (v) {
        Util.addClass(document.body, BODY_CLASS_NAME);
      } else {
        Util.removeClass(document.body, BODY_CLASS_NAME);
      }
    },
    async chatPushMemberMsg(message) {
      if (isEmpty(message)) {
        return;
      }
      const extra = await RongYun.MessageManager.getInstance().getExtraByMessage(
        message
      );
      const { title, userId } = extra;
      if (this.user.userId !== userId) {
        return;
      }
      this.showPushMemberMsg = true;
      this.memberMsgTitle = title;
      // clearTimeout(this.pushUserMsgTimeOut);
      // this.pushUserMsgTimeOut = setTimeout(() => {
      //   this.showPushMemberMsg = false;
      //   this.$store.commit("SET_CHAT_PUSH_MEMBER_MSG", null);
      // }, 4000);
    }
  },
  created() {
    this.$store.dispatch("queryCmsQrcodesAndServicer");
    this.handleCopyExpandCode();
    this.getPriMsgNoticeStatus();
    nativeAppUtil.getDevice(); // 获取webView设备信息
  },
  mounted() {
    let vm = this;
    document.addEventListener("touchmove", () => {
      vm.$store.commit("getTransitionPop", true);
      clearTimeout(vm.popTimer);
      vm.popTimer = setTimeout(() => {
        vm.$store.commit("getTransitionPop", false);
      }, 400);
    });
  },
  beforeDestroy() {
    // this.priMsgTimer && clearTimeout(this.priMsgTimer);
  },
  methods: {
    handleShowNotice() {
      const { path } = this.$route;
      this.showNotice =
        path.indexOf("lottery/games") < 0 &&
        path.indexOf("redPacket") < 0 &&
        path.indexOf("feedbackActive") < 0 &&
        path.indexOf("agencyCenter/promotion") < 0 &&
        path.indexOf("brandList") < 0 &&
        path.indexOf("yebcs") < 0 &&
        path.indexOf("lend/mycs") < 0 &&
        path.indexOf("DragonExplain") < 0;
    },
    toggleHomeClz() {
      const { path } = this.$route;
      if (path.includes("home") && !this.appLoad) {
        if (!this.h5CanReceiveRedPacket) {
          Util.addClass(document.body, "home");
        }
      } else {
        Util.removeClass(document.body, "home");
      }
    },
    getPriMsgNoticeStatus() {
      let isOpenPriMsgNotice = localStorage.getItem("isOpenPriMsgNotice");
      isOpenPriMsgNotice = isOpenPriMsgNotice ? !!+isOpenPriMsgNotice : true;
      this.$store.commit(
        "IS_OPEN_PRIVATE_MSG_NOTICE_SWITCH",
        isOpenPriMsgNotice
      );
    },
    handleCopyExpandCode() {
      // 复制邀请码
      const query = this.$route.query;
      const ttpasteVal = query["ttpaste"];
      const ttcode = query["ttcode"];
      const expCode = query["exp"];
      if (expCode) {
        localStorage.setItem(
          "exp",
          JSON.stringify({ value: expCode, time: new Date().getTime() })
        );
        downappurl({ exp: expCode });
      }
      if (!localStorage.getItem("ttpaste") && ttpasteVal) {
        localStorage.setItem("ttpaste", ttpasteVal);
      }
      if (ttpasteVal) {
        Dialog.alert({
          message: this.$tex("已为您复制邀请码")
        }).then(() => {
          Util.copyText(`ttpaste=${ttpasteVal}&ttcode=${ttcode}`);
        });
      } else if (!isEmpty(ttcode)) {
        // Dialog.alert({
        //   message: this.$tex("已为您复制邀请码,马上打开app"),
        // }).then(() => {
        //   Util.copyText(`ttcode=${ttcode}`);
        // });
        Util.copyText(`ttcode=${ttcode}`);
      }
      if (!isEmpty(ttcode)) {
        if (ttcode === "TG_GAME") {
          if (this.pageTemplate.index === 3) {
            this.$router.push("/home");
          } else {
            this.$router.push("/lottery");
          }
        } else if (ttcode === "CHAT_ROOM_LIST") {
          this.$router.push("/chatRoomList");
        } else {
          this.$router.push(`/lottery/games/${ttcode}`);
        }
      }
    },
    jumpNotice() {
      this.$store.commit("SET_CURRENT_CHAT_PRIVATE_RECEIVE_USER", this.hisInfo);
      this.$router.push({
        name: "privateRoom"
      });
      this.closePrivateMsgDialog();
    },
    closePrivateMsgDialog() {
      this.$store.commit("IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE", {
        hisInfo: {},
        isShowNotice: false
      });
    },
    playMsgVoice() {
      if (!this.$refs.recePriMsgAudio) return;
      if (this.$refs.recePriMsgAudio.played) {
        this.$refs.recePriMsgAudio.pause();
      }
      this.$refs.recePriMsgAudio.currentTime = 0.0;
      this.$refs.recePriMsgAudio.play();
    },
    jumpMemberMsg() {
      this.closeMemberMsgDialog();
      this.$router.push("/information/user");
    },
    closeMemberMsgDialog() {
      // clearTimeout(this.pushUserMsgTimeOut);
      this.showPushMemberMsg = false;
      this.$store.commit("SET_CHAT_PUSH_MEMBER_MSG", null);
    },
    hideMask() {
      this.show = false;
    },
    showPopUp() {
      this.show = true;
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~">>>";
@vh: 6.67vh;
@vw: 3.75vw;
.r-gift {
  position: fixed;
  right: 12 / @vw;
  bottom: 54 / @vw;
  z-index: 9999;
  a {
    display: block;
    img {
      width: 91 / @vw;
      display: block;
    }
  }
}
//@{deep} .mint-popup {
//  background-color: rgba(0, 0, 0, 0);
//  top: 50%;
//  left: 0;
//  right: 0;
//  transform: translateY(-50%);
//  transition: all 0.2s ease-in-out 0.1s;
//}
.popup-mask {
  width: 96%;
  height: auto;
  margin: 0 auto;
  background-size: cover;
  max-width: 60vh;
  display: grid;
  place-items: center;
  //    background:url('~@/assets/images/regTxt.png') no-repeat center center/338 / @vw  auto;
  .popup-close {
    display: inline-block;
    position: absolute;
    //top: 14 / @vh;
    bottom: -40 / @vw;
    //right: 66 / @vw;
    width: 28 / @vw;
    height: 28 / @vw;
    background: url("~@/assets/images/home/guanbi.png") no-repeat center center /
      contain;
  }

  .popup-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -49.5 / @vw;
    width: 152 / @vw;
    height: 35.5 / @vw;
    line-height: 35.5 / @vw;
    margin: 0 auto;
    text-align: center;
    font-size: 16 / @vw;
    color: #b56408;
    background: url("~@/assets/images/popConfirm.png") no-repeat center
      center/152 / @vw auto;
  }
}
</style>
